import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/shipdate/`;

/** Public/default ship dates (no warehouse-specific rounds). */
const getShipDates = async () => {
    return await axios.get(API_URL);
};

/**
 * Admin full list (includes warehouse-specific rounds).
 * operational=true → หน้าเลือกรอบ: ตัดรอบล่วงหน้าเกิน 7 วัน + รอบที่ปิดไว้ออก
 * (default false = หน้าจัดการรอบ เห็นครบ)
 */
const getShipDatesManage = async ({ operational = false } = {}) => {
    return await axios.get(`${API_URL}manage`, {
        params: operational ? { operational: true } : {},
    });
};

const addShipDate = async (formData) => {
    return await axios.post(API_URL, formData);
};

const editShipDate = async (shipDateId, updatedData) => {
    return await axios.put(API_URL + shipDateId , updatedData);
};

const deleteShipDate = async (shipDateId) => {
    return await axios.delete(API_URL + shipDateId);
};

export default {
    getShipDates,
    getShipDatesManage,
    addShipDate,
    editShipDate,
    deleteShipDate
};
